import type {
  ClinicianMeetingOffer,
  StaffBookMeetingRequest,
  StaffBookMeetingResult,
  StaffMeetingBookingOptions,
} from "@care-by-ella/contracts";
import { API_BASE, apiFetch, tenantHeader, withCredentials } from "./api";
import { jsonOr401 } from "./clinician-api";

// TES-1168 — "Boka nytt vårdmöte" from the patient overview: the form's
// options, the booking (free, or a paid offer the patient confirms), and the
// offers still waiting for her.

const patientBase = (patientId: string) =>
  `${API_BASE}/employee-api/v1/patients/${encodeURIComponent(patientId)}`;

export async function fetchMeetingBookingOptions(): Promise<StaffMeetingBookingOptions> {
  const res = await apiFetch(
    `${API_BASE}/employee-api/v1/meeting-booking/options`,
    { headers: tenantHeader(), ...withCredentials },
  );
  return jsonOr401(res);
}

export async function bookPatientMeeting(
  patientId: string,
  body: StaffBookMeetingRequest,
): Promise<StaffBookMeetingResult> {
  const res = await apiFetch(`${patientBase(patientId)}/meetings`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...tenantHeader() },
    body: JSON.stringify(body),
    ...withCredentials,
  });
  return jsonOr401(res);
}

export async function fetchMeetingOffers(
  patientId: string,
): Promise<{ offers: ClinicianMeetingOffer[] }> {
  const res = await apiFetch(`${patientBase(patientId)}/meeting-offers`, {
    headers: tenantHeader(),
    ...withCredentials,
  });
  return jsonOr401(res);
}

export async function cancelMeetingOffer(
  patientId: string,
  offerId: string,
): Promise<{ refunded: boolean }> {
  const res = await apiFetch(
    `${patientBase(patientId)}/meeting-offers/${encodeURIComponent(offerId)}/cancel`,
    {
      method: "POST",
      headers: tenantHeader(),
      ...withCredentials,
    },
  );
  return jsonOr401(res);
}
